<template>
    <div class="detail">
        <div class="swiper">
            <div class="swiper-container personal">
                <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="item in appShow" :key="item">
                        <img :src="item" class="app_show">
                    </div>
                </div>
            </div>
            <div class="swiper-button-prev" v-if="appShow.length > 1">
                <i class="el-icon-arrow-left"></i>
            </div>
            <div class="swiper-button-next" v-if="appShow.length > 1">
                <i class="el-icon-arrow-right"></i>
            </div>
        </div>
  </div>
  
</template>

<script type="text/javascript">
    export default {
        props: {
            appDetail: {
                type: Object,
                default: () => ({})
            }
        },
        data() {
            return {
                appShow: []
            }
        },
        watch: {
            appDetail: {
                handler (val) {
                    if (!Object.keys(val).length) return
                    const { app_show: appShow } = val
                    this.appShow = appShow
                    // 轮播图片加载完毕后初始化swiper
                    this.$nextTick(() => {
                        let app_show_num = appShow.length
                        if (app_show_num!=1) {  // 图片数量不为1的时候
                            for (var i = 0; i < app_show_num; i++) {
                                let img = new Image()
                                img.src = appShow[i]
                                if (appShow[i]=="") {  // 图片为空时
                                    app_show_num--
                                    if (!app_show_num) {
                                        this.initSwiper()
                                    }
                                }
                                img.onload = () => {
                                    app_show_num--
                                    if (!app_show_num) {
                                        this.initSwiper()
                                    }
                                }
                            }
                        }
                    })
                },
                immediate: true
            }
        },
        methods:{
            initSwiper() {
                let swiper = new Swiper('.swiper-container.personal', {
                    nextButton: '.swiper-button-next',
                    prevButton: '.swiper-button-prev',
                    paginationClickable: true,
                    spaceBetween: 30,
                    centeredSlides: true,
                    autoplay: 2500,
                    autoplayDisableOnInteraction: false,
                    loop: true
                })
                $('.swiper-button-prev').on('click', function(e){
                    e.preventDefault()
                    swiper.swipePrev()
                })
                $('.swiper-button-next').on('click', function(e){
                    e.preventDefault()
                    swiper.swipeNext()
                })
            }
        }
    }
</script>

<style media="screen" lang="scss">
    .swiper {
        padding: 0 60px;
        position: relative;
        position: relative;
        // cursor: -webkit-grab;
        .swiper-button-prev,
        .swiper-button-next{
            position: absolute;
            top: 50%;
            margin-top: -60px;
            width: 40px;
            height: 120px;
            background: #f0f1f5;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 2px;
            clip: auto;
            cursor: pointer;
            i {
                font-size: 20px;
                color: #979ba5;
                font-weight: 700;
            }
            &:hover{
                i {
                color: #63656e;
                }
            }
        }
        .swiper-button-prev{
            left: 7px;
        }
        .swiper-button-next{
            right: 0px;
        }
        .swiper-container{
            width: 1061px;
            height: 560px;
            img{
                width: 1061px;
                height: 560px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// pro_detail.vue?fda4ea1e